const awsmobile = {
  environmentVariables (Config) {
    let configDetails = {
      Auth: {
        mandatorySignIn: true,
        region: Config.region,
        userPoolId: Config.userPoolId,
        userPoolWebClientId: Config.userPoolWebClientId
      },
      API: {
        endpoints: [{
          name: 'AnalyticsAPI',
          endpoint: Config.endpoint,
          region: Config.region
        }]
      },
      Analytics: {
        disabled: true
      }
    }
    return configDetails
  }
}

export default awsmobile
